import { HoldTypeResponseDto } from '@planning/app/api'
import { holdTypeService } from '@planning/services'
import { action, makeObservable, observable } from 'mobx'

export class HoldTypesViewStore {
  items: HoldTypeResponseDto[] = []

  constructor() {
    makeObservable(this, {
      items: observable,
      fetch: action,
      remove: action,
      upsert: action,
    })
  }

  fetch = async () => {
    const data = await holdTypeService.get(true)
    this.items = data
  }

  getById = async (id: number): Promise<HoldTypeResponseDto | undefined> => {
    return await holdTypeService.getById(id)
  }

  remove = async (id: number) => {
    await holdTypeService.delete(id)
  }

  upsert = async (data: Omit<HoldTypeResponseDto, 'id'> & { id?: number }) => {
    if (data.id !== undefined) {
      await holdTypeService.update(data as HoldTypeResponseDto)
    } else {
      await holdTypeService.create(data)
    }
  }
}
